module.exports = __webpack_public_path__ + "img/21-SPOLVERINO-ORGOGLIO-U-COLORI-GARZA-RICAMO-SMERALDO4COPIA.54071f06.jpg";